import type { IconProps } from './types';

export function Colar({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M48 60 Q48 168 128 184 Q208 168 208 60" />
      <path d="M128 184 Q128 192 128 200" />
      <path d="M112 216 Q128 214 144 216 Q136 228 128 240 Q120 228 112 216 Z" />
    </svg>
  );
}
